import { useDispatch, useSelector } from "react-redux";
import PageWrapper from "../../shared/wizard/PageWrapper";
import Styles from "./ClaimSentInfo.module.css";
import { clearAnonAttachmentFailures } from "../../../store/actions/anonymousForms";
import { claimsMailBox } from "../../../constants/messages";

function ClaimSentInfo() {
  const dispatch = useDispatch();
  const referenceNumber = useSelector(
    (state) => state.anonymousForms.referenceNumber
  );
  const urlParams = useSelector(
    (state) => state.anonymousForms.urlParamsToRegister
  );
  const attachmentFailures = useSelector(
    (state) => state.anonymousForms.attachmentFailures
  );
  const thankYouMessage = (
    <div>
      <p className={Styles.regularText}>Dear Customer,</p>
      <p className={Styles.regularText}>
        Thank you for submitting your claim with us online.
      </p>
      {referenceNumber && (
        <p className={Styles.regularText}>
          Your claim number is{" "}
          <span className={Styles.referenceNumber}>{referenceNumber}</span>.
        </p>
      )}
      <p className={Styles.regularText}>
        An email confirmation will be sent to the email address provided, and a
        Claims Representative will make contact within 24 hours, or on the next
        business day.
      </p>
    </div>
  );
  const signUpMessage = (
    <p className={Styles.regularText}>
      Are you a Utica National insured? Sign up for our online Customer Care
      Center to access details about your claim, including adjuster information,
      as it becomes available. You can also view other policy and billing
      information.
    </p>
  );

  const goToSignUp = () => {
    let url = process.env.REACT_APP_CUSTOMER_CARE_SIGNUP_URL;
    //send any relevant registration information in
    //the url, from urlParams
    const name = encodeURIComponent(urlParams.name);
    const policyNumber = encodeURIComponent(
      urlParams.policyNumber.replace(/\s+/g, "")
    );
    const email = encodeURIComponent(urlParams.email);
    const phone = encodeURIComponent(urlParams.phone.replace(/\s+/g, ""));
    url = `${url}?name=${name}&policyNumber=${policyNumber}&email=${email}&phone=${phone}`;
    window.location.href = url;
  };

  const goToLogin = () =>
    (window.location.href = process.env.REACT_APP_CUSTOMER_CARE_LOGIN_URL);

  window.onbeforeunload = () => dispatch(clearAnonAttachmentFailures());

  return (
    <div className={Styles.thankYouDiv}>
      <div className={Styles.pageContainer}>
        <PageWrapper legendInfo="Thank You">
          <div className={Styles.messageContainer}>
            {thankYouMessage}

            {attachmentFailures?.length > 0 && (
              <p className={Styles.regularText}>
                <em>
                  Note: Your document
                  {attachmentFailures.length > 1 && "s"}{" "}
                  {attachmentFailures.map((fileName, index) =>
                    index !== attachmentFailures.length - 1
                      ? `"${fileName}", `
                      : `"${fileName}"`
                  )}{" "}
                  failed to upload. Please email your document
                  {attachmentFailures.length > 1 && "s"} to{" "}
                  <a href={`mailto:${claimsMailBox}`}>{claimsMailBox}</a> and
                  attention your claim number.
                </em>
              </p>
            )}

            <button className={Styles.registerButton} onClick={goToLogin}>
              Return to Login
            </button>

            <p className={Styles.blueText}>Online Customer Care Center</p>

            {signUpMessage}

            <button className={Styles.registerButton} onClick={goToSignUp}>
              Register
            </button>
          </div>
        </PageWrapper>
      </div>
    </div>
  );
}

export default ClaimSentInfo;
